import { render } from "./GroupTable.vue?vue&type=template&id=26f760ce&ts=true"
import script from "./GroupTable.vue?vue&type=script&lang=ts"
export * from "./GroupTable.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__